<template>
	<div>
		<v-container grid-list-sm fluid class="pa-0">
			<v-form ref="AmazonLauncherForm">
				<v-layout row wrap>
					<v-flex xs2>
						<v-autocomplete
							outline
							dense
							:rules="[required]"
							class="dense_input mb-3"
							label="Type*"
							clearable
							@change="emitChange()"
							:items="package_types"
							v-model="form.parameters.package_type">
						</v-autocomplete>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							outline
							:rules="[required]"
							class="dense_input mb-3"
							@change="emitChange()"
							v-model="form.parameters.title"
							label="Titre*">
						</v-text-field>
					</v-flex>
					<v-flex xs4>
						<v-text-field
							outline
							:rules="[required]"
							class="dense_input mb-3"
							@change="emitChange()"
							v-model="form.parameters.label"
							label="Label*">
						</v-text-field>
					</v-flex>
				</v-layout>

				<span class="title">
					Sélection des assets
					<v-chip
						label small outline
						class="my-0"
						color="primary"
						v-if="nbAssets > 0">
						{{ nbAssets }} selectionnés
					</v-chip>
				</span>

				<div v-if="nbAssets > 0">
					<div
						class="asset-section elevation-4"
						v-for="(asset, assetIndex) in form.parameters.assets.list"
						:key="asset.filepath">
						<span class="caption d-block">
							<v-btn flat icon @click="removeAsset(assetIndex)" class="ma-0">
								<v-icon>close</v-icon>
							</v-btn>
							{{ asset.filepath }}
						</span>
						<v-layout row wrap>
							<v-flex xs2>
								<v-autocomplete
									outline
									dense
									:rules="[required]"
									class="dense_input"
									label="Type"
									clearable
									@change="onAssetTypeChange(assetIndex)"
									:items="asset_types"
									v-model="asset.asset_type">
								</v-autocomplete>
							</v-flex>
							<v-flex xs2>
								<v-autocomplete
									outline
									dense
									:rules="[]"
									v-if="showRole(asset.asset_type)"
									class="dense_input"
									label="Rôle"
									clearable
									@change="emitChange()"
									:items="asset_roles"
									v-model="asset.role">
								</v-autocomplete>
							</v-flex>
							<v-flex xs5 v-if="asset.asset_type">
								<v-autocomplete
									clearable
									label="Langue"
									outline
									:rules="[]"
									class="dense_input input-lg"
									dense
									:items="languages"
									@change="emitChange()"
									item-text="text"
									item-value="code"
									v-model="asset.language">
								</v-autocomplete>
							</v-flex>
							<v-flex xs3>
								<v-autocomplete
									outline
									dense
									clearable
									:rules="[]"
									v-if="asset.asset_type === 'Audio'"
									class="dense_input"
									label="Audio Type"
									@change="emitChange()"
									:items="audio_types"
									v-model="asset.audio_type">
								</v-autocomplete>
								<v-autocomplete
									outline
									dense
									clearable
									:rules="[]"
									v-if="asset.asset_type === 'Subtitle'"
									class="dense_input"
									label="Subtitle Type"
									@change="emitChange()"
									:items="subtitle_types"
									v-model="asset.subtitle_type">
								</v-autocomplete>
							</v-flex>
						</v-layout>
					</div>
				</div>

				<v-layout class="mt-3 mb-0">
					<v-btn
						color="primary"
						small
						class="mt-0 mx-1 color--text text-none"
						ref="explorer_btn"
						@click="showExplorer = true">
						<v-icon class="mr-1">add</v-icon>
						Fichiers via le filesystem
					</v-btn>
					<v-btn
						color="primary"
						small
						class="mt-0 mx-1 color--text text-none"
						ref="asset_finder_btn"
						@click="showAssetFinder = true">
						<v-icon class="mr-1">add</v-icon>
						Fichiers via asset finder
					</v-btn>
					<v-menu
						v-model="naming_help_menu"
						:close-on-content-click="false"
						:nudge-width="200"
						offset-x>
						<template v-slot:activator="{ on }">
							<v-btn
								small flat
								color="primary"
								class="text-none mt-0 mx-1"
								v-on="on">
								<v-icon class="mr-1">help_outline</v-icon>
								Nomenclature pour auto-remplissage
							</v-btn>
						</template>
						<v-card class="background darken-1">
							<v-card-title class="pa-2">
								<a
									:href="nomenclature_spec"
									target="_blank"
									class="title">
									<v-icon color="primary" class="mr-1">
										open_in_new
									</v-icon>
									Spécifications Amazon
								</a>
								<v-spacer></v-spacer>
								<v-btn
									flat icon
									@click="naming_help_menu = false"
									class="ma-0">
									<v-icon>close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text class="pa-2">
								<table class="naming-table">
									<tr>
										<td class="subheading background--text text--lighten-4">
											[PartnerAlias]
										</td>
										<td class="subheading">-</td>
										<td class="subheading background--text text--lighten-4">
											[UniqueID]
										</td>
										<td class="subheading">-</td>
										<td class="subheading">[ContentType]</td>
										<td class="subheading">-</td>
										<td class="subheading">[AssetType]</td>
										<td class="subheading">-</td>
										<td class="subheading">[LanguageCode]</td>
										<td class="subheading">-</td>
										<td class="subheading">[Territory]</td>
										<td class="subheading">-</td>
										<td class="subheading background--text text--lighten-4">
											[OtherInformation]
										</td>
										<td class="subheading">.</td>
										<td class="subheading background--text text--lighten-4">
											xxx
										</td>
									</tr>
									<tr>
										<td class="background--text text--lighten-4">
											Non utilisé
										</td>
										<td></td>
										<td class="background--text text--lighten-4">
											Non utilisé
										</td>
										<td></td>
										<td>
											<div class="primary--text">Full</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												Rôle = Feature
											</div>
											<div class="primary--text">Trailer</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												Rôle = Trailer
											</div>
										</td>
										<td></td>
										<td>
											<div class="primary--text">Mezz</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Video
											</div>
											<div class="primary--text">Dubcard</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Dubcard
											</div>
											<div class="primary--text">Audio</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Audio
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												audio_type = primary
											</div>
											<div class="primary--text">Audio_Narration</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Audio
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												audio_type = narration
											</div>
											<div class="primary--text">Audio_Dialog</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Audio
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												audio_type = dialog centric
											</div>
											<div class="primary--text">Audio_Commentary</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Audio
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												audio_type = commentary
											</div>
											<div class="primary--text">Caption</div>
											<div class="primary--text">Subtitle</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Subtitle
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												subtitle_type = Normal
											</div>
											<div class="primary--text">Caption_sdh</div>
											<div class="primary--text">Subtitle_sdh</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Subtitle
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												subtitle_type = SDH
											</div>
											<div class="primary--text">Caption_Forced</div>
											<div class="primary--text">Subtitle_Forced</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												type = Subtitle
											</div>
											<div>
												<v-icon small color="background lighten-4">
													subdirectory_arrow_right
												</v-icon>
												subtitle_type = Forced
											</div>
										</td>
										<td></td>
										<td>Requis</td>
										<td></td>
										<td>Requis</td>
										<td></td>
										<td class="background--text text--lighten-4">
											Non utilisé
										</td>
										<td></td>
										<td></td>
									</tr>
								</table>
							</v-card-text>
						</v-card>
					</v-menu>
					<v-spacer></v-spacer>
					<v-btn
						v-if="nbAssets > 0"
						color="warning"
						small
						ref="removeFiles_btn"
						class="mt-0 mx-1 color--text text-none"
						@click="form.parameters.assets.list = [];emitChange()">
						<v-icon class="mr-1">close</v-icon>
						Suppprimer les assets
					</v-btn>
				</v-layout>

			</v-form>
		</v-container>

		<v-card class="pa-2 mb-3" v-if="debug">
			<tree-view :data="form" :options="{maxDepth: 3, rootObjectKey: 'Output'}" />
		</v-card>

		<v-card class="pa-2" v-if="debug">
			<tree-view :data="wf_data" :options="{maxDepth: 0, rootObjectKey: 'Job Descriptor'}" />
		</v-card>

		<Explorer
			v-if="showExplorer"
			assetType="file"
			:multiselect="true"
			toolbarTitle="Selectionnez des assets présents sur le filesystem"
			:no_previous_path="true"
			@close="showExplorer = false"
			@selectedAssets="addAssets($event)">
		</Explorer>

		<AssetFinder
			v-if="showAssetFinder"
			:multiselect="true"
			toolbarTitle="Selectionnez des assets via asset finder"
			@close="showAssetFinder = false"
			@selectedAssets="addAssets($event)">
		</AssetFinder>

	</div>
</template>

<script>
import {
	asset_types,
	asset_roles,
	audio_types,
	subtitle_types,
	package_types,
	languages,
	isValidLanguage } from '@/pages/packages/amazon_package_global/amazon_enums.js'
import Explorer from '@/components/modal_explorer.vue'
import AssetFinder from '@/components/modal_asset_finder.vue'
export default {
	props: [ 'wf_data', 'debug', 'details' ],
	components: {
		Explorer,
		AssetFinder
	},
	data () {
		return {
			form: {
				isValid: false,
				jobdescriptorID: null,
				parameters: {}
			},
			nomenclature_spec: 'https://videocentral.amazon.com/home/help?topicId=GGKSYG247W2M6MMC&ref_=avd_sup_GGKSYG247W2M6MMC',
			showExplorer: false,
			showAssetFinder: false,
			selected_assets: [],
			naming_help_menu: false,
			asset_types: asset_types,
			asset_roles: asset_roles,
			audio_types: audio_types,
			subtitle_types: subtitle_types,
			package_types: package_types,
			languages: languages,
			required: v => (v !== '' && v !== null && v !== undefined) || 'Requis'
		}
	},
	computed: {
		nbAssets () {
			try {
				return this.form.parameters.assets.list.length
			} catch (error) {
				return 0
			}
		}
	},
	methods: {
		showRole (asset_type) {
			let needed = [
				'Video',
				'Audio',
				'Subtitle'
			]
			return needed.indexOf(asset_type) !== -1
		},
		buildAssetObj (asset) {
			let assetObj = {
				filepath: asset.path,
				asset_type: null,
				role: null,
				language: null,
				audio_type: null,
				subtitle_type: null
			}
			if (asset.name) {
				let assetNameArr = asset.name.split('.')[0].split('-')
				let contentType = (assetNameArr[2] || '').toLowerCase()
				if (contentType === 'trailer') {
					assetObj.role = 'Trailer'
				} else if (contentType === 'full') {
					assetObj.role = 'Feature'
				}

				let assetType = (assetNameArr[3] || '').toLowerCase()
				if (assetType.indexOf('mezz') > -1) {
					assetObj.asset_type = 'Video'
				} else if (assetType.indexOf('audio') > -1) {
					assetObj.asset_type = 'Audio'
					if (assetType.indexOf('narration') > -1) {
						assetObj.audio_type = 'narration'
					} else if (assetType.indexOf('dialog') > -1) {
						assetObj.audio_type = 'dialog centric'
					} else if (assetType.indexOf('commentary') > -1) {
						assetObj.audio_type = 'commentary'
					} else {
						assetObj.audio_type = 'primary'
					}
				} else if (assetType.indexOf('caption') > -1 ||
					assetType.indexOf('subtitle') > -1) {
					assetObj.asset_type = 'Subtitle'
					if (assetType.indexOf('sdh') > -1) {
						assetObj.subtitle_type = 'SDH'
					} else if (assetType.indexOf('forced') > -1) {
						assetObj.subtitle_type = 'Forced'
					} else {
						assetObj.subtitle_type = 'Normal'
					}
				} else if (assetType.indexOf('dubcard') > -1) {
					assetObj.asset_type = 'Dubcard'
				}

				let language = (assetNameArr[4])
				let territory = (assetNameArr[5])
				if (language && territory) {
					let languageCode = `${language}-${territory}`
					if (isValidLanguage(languageCode)) {
						assetObj.language = languageCode
					}
				}
			}
			return assetObj
		},
		addAssets (assets) {
			assets.map(asset => {
				let assetIsNew = true
				this.form.parameters['assets'].list.map(selected_asset => {
					if (selected_asset.filepath === asset.path) {
						assetIsNew = false
					}
				})
				if (assetIsNew) {
					let assetObj = this.buildAssetObj(asset)
					this.form.parameters['assets'].list.push(assetObj)
				}
			})
			this.$nextTick((arg) => {
				this.emitChange()
			})
		},
		removeAsset (assetIndex) {
			this.form.parameters.assets.list.splice(assetIndex, 1)
			this.$nextTick((arg) => {
				this.emitChange()
			})
		},
		onAssetTypeChange (assetIndex) {
			let assetType = this.form.parameters['assets'].list[assetIndex].asset_type
			let assetObj = {}
			if (assetType === 'Video') {
				assetObj = {
					asset_type: assetType,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language
				}
			} else if (assetType === 'Dubcard') {
				assetObj = {
					asset_type: assetType,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					language: this.form.parameters['assets'].list[assetIndex].language
				}
			} else if (assetType === 'Audio') {
				assetObj = {
					asset_type: assetType,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language,
					audio_type: this.form.parameters['assets'].list[assetIndex].audio_type
				}
			} else if (assetType === 'Subtitle') {
				assetObj = {
					asset_type: assetType,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath,
					role: this.form.parameters['assets'].list[assetIndex].role,
					language: this.form.parameters['assets'].list[assetIndex].language,
					subtitle_type: this.form.parameters['assets'].list[assetIndex].subtitle_type
				}
			} else {
				assetObj = {
					asset_type: assetType,
					filepath: this.form.parameters['assets'].list[assetIndex].filepath
				}
			}
			this.$set(this.form.parameters.assets.list, assetIndex, assetObj)
			this.emitChange()
		},
		validate () {
			let validity = this.$refs['AmazonLauncherForm'].validate()
			let nbAsset = this.$commons.deepGet(this.form, 'parameters.assets.list', []).length
			if (nbAsset === 0) validity = false
			return validity
		},
		emitChange () {
			this.form.isValid = this.validate()
			this.$nextTick((arg) => {
				this.$emit('change', [this.form])
			})
		}
	},
	mounted () {
		this.$emit('modal_width', '1200px')
		this.form.parameters = {}
		this.form.jobdescriptorID = this.wf_data.descriptor_id
		this.form.label = this.wf_data.label
		this.form.jobDescriptorVersion = this.wf_data.version_number
		this.wf_data.parameters.map(desc => {
			let defaultValue = ''
			if (desc.default !== '') defaultValue = desc.default
			if (this.details) {
				if (this.details.hasOwnProperty(desc.name)) {
					defaultValue = this.details[desc.name]
				}
			}
			this.form.parameters[desc.name] = defaultValue
		})
	},
	destroyed () {
		this.$emit('modal_width', null)
	}
}
</script>

<style scoped lang="stylus">
.dense_input
	margin-top: 0
	>>>.v-input__slot
		margin-top: 0

>>>.v-input
	margin: 0 .2em
	.v-messages
		min-height: inherit

.asset-section
	border: thin solid var(--v-background-lighten2)
	margin: 10px 0 10px 0
	padding: 0 5px 5px 5px

.naming-table
	td
		padding: 4px 8px
		vertical-align: top
	tr:first-child
		border-bottom: 1px solid var(--v-background-lighten1)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_amazon_package_global.vue